// Dependencies
import React, { Component } from 'react';
import { Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';

//Containers
import ReloadsPhoneContainer from './../../../containers/Reloads/ReloadsPhoneContainer';

//Actions
import { getPageInfo } from './../../../reducers/generalReducer';

//Components
import CountdownTimer from './../../Global/Header/CountdownTimer';

class ReloadsPhone extends Component {
  render() {
    const { info } = this.props;
    return (
      <Col xs={12} className="homeContainer">
        <CountdownTimer/>
        <Row>
          <Container className="bg-primary">
            <section className="border mt-5 mb-4 p-4 back-white border-container">
              <h3 className="first-title text-center my-5">Recargas de <span className="color-main">Celular</span></h3>
              <div className="font-montserrat-light text-center text-size-medium mb-5" dangerouslySetInnerHTML={{__html: info.description}} />
              <ReloadsPhoneContainer />
            </section>
          </Container>
        </Row>
      </Col>
    );
  }
}

const mapStateToProps = (state) => {
  const { loading, error } = state.general.pages;
  return {
    loading,
    error,
    info: getPageInfo(state, 'recargas-celular')
  };
};

export default connect(mapStateToProps)(ReloadsPhone);
